"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCameraNotPresent = exports.isCameraPermissionDenied = exports.isErrorState = exports.isLensLoading = exports.isLensInactive = exports.isLensActive = void 0;
const liveLensState_1 = require("../liveLensState");
function isLensActive(liveLensState) {
    return liveLensState === liveLensState_1.LiveLensState.APPLIED;
}
exports.isLensActive = isLensActive;
function isLensInactive(liveLensState) {
    return liveLensState === liveLensState_1.LiveLensState.INACTIVE || liveLensState === liveLensState_1.LiveLensState.REQUESTED;
}
exports.isLensInactive = isLensInactive;
function isLensLoading(liveLensState) {
    return (liveLensState === liveLensState_1.LiveLensState.DOWNLOADING ||
        liveLensState === liveLensState_1.LiveLensState.BOOTSTRAPPING ||
        liveLensState === liveLensState_1.LiveLensState.GETTING_PERMISSION ||
        liveLensState === liveLensState_1.LiveLensState.LOADING_LENS ||
        liveLensState === liveLensState_1.LiveLensState.APPLYING_LENS);
}
exports.isLensLoading = isLensLoading;
function isErrorState(liveLensState) {
    return (liveLensState === liveLensState_1.LiveLensState.FAILED ||
        liveLensState === liveLensState_1.LiveLensState.CAMERA_NOT_FOUND ||
        liveLensState === liveLensState_1.LiveLensState.CAMERA_PERMISSION_DENIED);
}
exports.isErrorState = isErrorState;
function isCameraPermissionDenied(liveLensState) {
    return liveLensState === liveLensState_1.LiveLensState.CAMERA_PERMISSION_DENIED;
}
exports.isCameraPermissionDenied = isCameraPermissionDenied;
function isCameraNotPresent(liveLensState) {
    return liveLensState === liveLensState_1.LiveLensState.CAMERA_NOT_FOUND;
}
exports.isCameraNotPresent = isCameraNotPresent;
//# sourceMappingURL=state-utils.js.map